import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { EmployeeService } from '../services/employee.service';
import { GroupService } from '../services/group.service';


@Component({
  selector: 'app-employee-insert',
  templateUrl: './employee-insert.component.html',
  styleUrls: ['./employee-insert.component.css']
})
export class EmployeeInsertComponent implements OnInit {
  name: string;
  username: string;
  password:string;
  group_id:string;
  routeId:boolean = true;
  image:any;
  groups: any;
  constructor(private employeeService: EmployeeService,
    private groupService: GroupService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router) {
      this.getGroups();
      
    const id = +this.route.snapshot.paramMap.get('id');
    if (id != 0) {
      this.routeId = false;
      this.editEmployee(id);
    }
  }

  ngOnInit() {
  }
  submit(employeeForm) {
    const id = +this.route.snapshot.paramMap.get('id');

    if (id == 0) {
      var test = {
        name:this.name,
        username:this.username,
        password:this.username,
        group_id:this.group_id,
        image:this.image,

      };
      const uploadData = new FormData();
      // uploadData.append('image', this.image, this.image.name);
      uploadData.append('name',this.name);
      uploadData.append('username',this.username);
      uploadData.append('password',this.password);
      uploadData.append('group_id',this.group_id);
      this.employeeService.saveEmployee(uploadData).subscribe(data => {
        // console.log(data);
        this.router.navigate(['/employees']);
      });
    } else {
      this.employeeService.updateEmployee(employeeForm, id).subscribe(data => {
        this.router.navigate(['/employees']);
      });
    }

  }

  onFileChange(event){
    this.image = event.target.files[0];
  }

  editEmployee(id) {
    this.employeeService.editEmployee(id).subscribe(data => {
      this.name = data.name,
        this.username = data.username,
        this.image = data.image,
        this.group_id = data.group_id

    });
  }

  getGroups(){
    this.groupService.getGroups().subscribe(data =>{
      this.groups = data;
      this.group_id = this.groups[0].id;
    });
  }

}
